<template>
    <div ref="scroller" class="vscroll-holder">
        <div class="vscroll-spacer" :style="{ height: heightTopSpacer + 'px' }"></div>
        <slot :visibleItems="visibleItems" />
        <div class="vscroll-spacer" :style="{ height: heightBottomSpacer + 'px' }"></div>
    </div>
</template>

<script>
import { EventBus } from "@/utils/EventBus";

export default {
    name: "VirtualScroll",
    props: {
        items: {
            type: Array,
            default: () => []
        },
        offset: {
            type: Number,
            default: 5
        },
        itemHeight: {
            type: Number,
            default: undefined
        }
    },
    data() {
        return {
            heightTopSpacer: 0,
            heightBottomSpacer: 0,
            visibleItems: []
        };
    },
    watch: {
        items: {
            deep: true,
            handler() {
                this.updateWindow();
            }
        }
    },
    mounted() {
        window.vscroll = this;
        this.checkScrollPosition();
        this.$refs.scroller.addEventListener("scroll", this.checkScrollPosition);
        this.$refs.scroller.addEventListener("wheel", this.checkScrollPosition);
        this.$refs.scroller.addEventListener("resize", this.checkScrollPosition);

        EventBus.$on("update-table", () => {
            this.$refs.scroller.scrollTop = 0;
            this.updateWindow;
        });
        EventBus.$on("update-table-view", this.updateWindow);
    },
    beforeDestroy() {
        this.$refs.scroller.removeEventListener("scroll", this.checkScrollPosition);
        this.$refs.scroller.removeEventListener("wheel", this.checkScrollPosition);
        this.$refs.scroller.removeEventListener("resize", this.checkScrollPosition);

        EventBus.$off("update-table");
        EventBus.$off("update-table-view");
    },
    methods: {
        checkScrollPosition(e = {}) {
            // prevent parent scroll
            // if moved with scrolling wheel
            if (
                (this.$refs.scroller.scrollTop === 0 && e.deltaY < 0) ||
                (Math.abs(
                    this.$refs.scroller.scrollTop -
                        (this.$refs.scroller.scrollHeight - this.$refs.scroller.clientHeight)
                ) <= 1 &&
                    e.deltaY > 0)
            ) {
                e.preventDefault();
            }

            this.updateWindow();
        },

        updateWindow: function() {
            const visibleItemsCount = Math.ceil(this.$refs.scroller.clientHeight / this.itemHeight);
            const totalScrollHeight = this.items.length * this.itemHeight;

            const firstVisibleIndex = Math.floor(this.$refs.scroller.scrollTop / this.itemHeight);

            /*
             * The Problem is :nth-child(2n) striped table layout:
             * If we only remove 1 item, the stripes are changing order.
             * Therefore, we subtract the modulo to make sure,
             * that always an even amount of articles gets added/removed from the list (e.g. 0 or 2).
             * */
            const firstCutIndex = Math.max(
                firstVisibleIndex - this.offset - (firstVisibleIndex % 2),
                0
            );
            const lastCutIndex = firstVisibleIndex + visibleItemsCount + this.offset;
            this.visibleItems = this.items.slice(firstCutIndex, lastCutIndex);
            // add the real index to the slice of items, so you can manipulate it
            // needed for select + shiftSelect
            this.visibleItems.forEach((item, i) => {
                item.realIndex = firstCutIndex + i;
            });

            this.heightTopSpacer = firstCutIndex * this.itemHeight;
            this.heightBottomSpacer =
                totalScrollHeight -
                this.visibleItems.length * this.itemHeight -
                this.heightTopSpacer;
        }
    }
};
</script>
<style scoped>
.vscroll-spacer {
    opacity: 0;
    clear: both;
}
</style>
